import { NgModule } from '@angular/core';
import { DIRECTIVES } from './stencil-generated';



@NgModule({
  declarations: [...DIRECTIVES],
  exports: [...DIRECTIVES],
})
export class PatternlibAngularWrapperModule { }
